import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { BackendPaths } from '@common/backend-paths';
import { DataService } from '@data/data.service';
import { InputComponent } from '@input/input/input.component';
import { NotificationService } from '@notification/notification.service';
import { StateService } from '@services/state.service';
import { parseDec } from '@util/utils';
import { AppConfigutationKeys } from 'src/app/app.configuration';

const passwordInputNames: string[] = [
  'oldpassword',
  'newpassword',
  'newpassword_repeat'
];

@Component({
  selector: 'app-settings-dialog',
  templateUrl: './settings-dialog.component.html'
})
export class SettingsDialogComponent implements OnInit {

  title = 'Einstellungen';

  passwords: any = {
    oldpassword: '',
    newpassword: '',
    newpassword_repeat: ''
  };

  protected _oldPw!: InputComponent;
  @ViewChild('oldpw', {
    read: InputComponent
  }) set oldpw(pwElem: InputComponent) {
    this._oldPw = pwElem;
  }

  protected _newPw!: InputComponent;
  @ViewChild('newpw', {
    read: InputComponent
  }) set newpw(pwElem: InputComponent) {
    this._newPw = pwElem;
  }

  protected _newPwRepeat!: InputComponent;
  @ViewChild('newpwrepeat', {
    read: InputComponent
  }) set newpwrepeat(pwElem: InputComponent) {
    this._newPwRepeat = pwElem;
  }

  screenIdx = 0;

  isAdmin = false;

  sbViewType = 1;

  constructor(
    public dialogRef: MatDialogRef<SettingsDialogComponent>,
    private dataService: DataService,
    private notificationService: NotificationService,
    private stateService: StateService
  ) {

    this.isAdmin = !!stateService.isAdmin();
  }

  ngOnInit(): void {
    const cfg = this.stateService.getLocalConfiguration(
      AppConfigutationKeys.RECEIPTS_VIEW
    ) || '';
    this.sbViewType = parseDec(cfg) || 2;
  }

  openChangePassword() {
    this.screenIdx = 1;
    this.title = 'Passwort ändern';
  }

  close() {
    this.dialogRef.close(null);
  }

  canSave = false;

  protected getPwInput(name: string): InputComponent | null {

    const res: any = {
      oldpassword: this._oldPw,
      newpassword: this._newPw,
      newpassword_repeat: this._newPwRepeat,
    };

    return (name && res[name]) ? res[name] : null;
  }

  setPassword(name: string, value: any) {

    if (name && passwordInputNames.indexOf(name) >= 0) {
      this.passwords[name] = value;
    }

    let elem = this.getPwInput(name);
    if (elem && elem.setError) {
      elem.setError('');
    }

    this.canSave = this.validatePasswordInputs(false);

    this.hasErrors = false;

    //MyLog.log('SET:', this.canSave, name, value, this.passwords)
  }

  validatePasswordInputs(trimInputs: boolean) {
    let result: boolean = true;
    for (let n of passwordInputNames) {
      let text = this.passwords[n];
      if (typeof text === 'string') {
        if (trimInputs) {
          text = text.trim();
        }
        result = result && text.length > 0;
      } else {
        return false;
      }
    }
    return result;
  }

  savePassword() {
    const errors: any = {};

    let hasErrors = false;

    for (let n of passwordInputNames) {
      this.passwords[n] = this.passwords[n].trim();

      const value = this.passwords[n];

      if (!value) {
        errors[n] = 'Eingabe ist leer';
        hasErrors = true;
        continue;
      }

      if (n !== 'oldpassword') {

        if (value.length < 5) {
          errors[n] = 'Passwort ist kürzer als 5 Zeichen';
          hasErrors = true;
          continue;
        }

        let hasLetter = false;

        let hasNumber = false;

        for (let i = 0; i < value.length; i++) {
          let letter = value[i];
          let num = parseDec(letter);
          if (Number.isInteger(num)) {
            hasNumber = true;
          }
          if (letter.toUpperCase() != letter.toLowerCase()) {
            hasLetter = true;
          }
        }

        if (!hasLetter || !hasNumber) {
          errors[n] = 'Passwort entspricht nicht den angegebenen Passwortregeln.';
          hasErrors = true;
          continue;
        }
      }
    }
    if (!hasErrors && this.passwords.newpassword !== this.passwords.newpassword_repeat) {
      errors.newpassword_repeat = 'Muss gleich dem neuen Passwort sein';
      hasErrors = true;
    }

    this.hasErrors = hasErrors;

    if (hasErrors) {

      for (let n of passwordInputNames) {
        if (errors[n]) {
          let elem = this.getPwInput(n);
          if (elem && elem.setError) {
            elem.setError(errors[n]);
          }
        }
      }

      this.notificationService.showErrors([
        'Eingaben sind ungültig'
      ]);
      this.canSave = false;
      return;
    }

    this.dataService.post(
      BackendPaths.PASSWORD_CHANGE,
      this.passwords
    ).subscribe((res: any) => {
      const result = res?.result;

      if (result?.success) {
        this.notificationService.showSuccess(
          result.msg || 'Passwort geändert',
          result.messages
        );

        this.dialogRef.close();
      } else {
        const errors = Array.isArray(result?.errors) ? result.errors : [
          'Unbekannter Fehler beim Ändern des Passworts'
        ];
        this.notificationService.showErrors(errors);
      }
    });

  }

  hasErrors = false;

  onSbViewTypeChange($event: MatRadioChange) {
    console.log('Change:', $event);
    if (typeof $event?.value === 'number') {
      this.stateService.setLocalConfiguration(
        AppConfigutationKeys.RECEIPTS_VIEW,
        $event.value
      );

      this.notificationService.showSuccess(
        "Änderungen für 'SB Quittungen drucken' lokal gespeichert"
      );
    }
  }
}
